// extracted by mini-css-extract-plugin
export default {"memberships":"MembershipPage_memberships__yRY4-","back":"MembershipPage_back__17bWC"};